import { MouseEvent, useCallback } from 'react';
import { useTranslations } from 'next-intl';
import { useEvent, useUnit } from 'effector-react';
import { calculateContextMenuPosition, openContextMenuEvent } from '@nx-frontend/shared/ui/context-menu';
import { IconsMap } from '@nx-frontend/shared/ui/icon';
import { $currentWorkspace } from '@nx-frontend/shared/store/current-workspace';
import { collapseAllItemsFx, expandAllItemsFx } from '@nx-frontend/shared/store/feature-menu-tree';
import {
  ContextMenuItemData,
  ContextMenuItemType,
  MenuType,
  UiContextMenuConfigPosition,
  UiContextMenuTheme,
} from '@nx-frontend/shared/types';

export const useOpenKitchenMenuContextFolders = () => {
  const [currentWorkspace] = useUnit([$currentWorkspace]);
  const [expandAllItems, collapseAllItems, openContextMenu] = useEvent([
    expandAllItemsFx,
    collapseAllItemsFx,
    openContextMenuEvent,
  ]);
  const t = useTranslations('sidebar');

  return useCallback(
    async (e: MouseEvent, useMousePos?: boolean) => {
      const items: ContextMenuItemData[] = [];
      const workspaceId = currentWorkspace.globalId;
      items.push({
        id: 'expandAll',
        title: t('sidebar-expand_all'),
        icon: IconsMap.EXPAND,
        type: ContextMenuItemType.DEFAULT,
        action: () => {
          expandAllItems({
            menuType: MenuType.WEBNOTES_MENU,
            workspaceId: workspaceId,
            collapseAllItems,
          });
        },
      });
      items.push({
        id: 'collapseAll',
        title: t('sidebar-collapse_all'),
        icon: IconsMap.COLLAPSE,
        type: ContextMenuItemType.DEFAULT,
        action: () => {
          collapseAllItems({ menuType: MenuType.WEBNOTES_MENU });
        },
      });

      openContextMenu({
        items,
        position: calculateContextMenuPosition(
          e.target,
          4,
          undefined,
          useMousePos ? { x: e.clientX, y: e.clientY } : undefined
        ),
        config: {
          position: UiContextMenuConfigPosition.BOTTOM_RIGHT,
          menuPadding: 0,
          theme: UiContextMenuTheme.LIGHT,
        },
      });
    },
    [collapseAllItems, currentWorkspace.globalId, expandAllItems, openContextMenu, t]
  );
};
